// https://malcoded.com/posts/angular-fundamentals-modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './auth-guard.service';
import { AdalService } from './adal.service';
//import { FrameRedirectComponent } from './frame-redirect/frame-redirect.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { routing } from './authentication.routing';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    routing
],
  declarations: [
  //  FrameRedirectComponent,
    LoginComponent,
    LogoutComponent
  ],
  exports: [

  ],
  providers: [
    AdalService, 
    AuthGuardService,
        
    //{ provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthGuardService }
  ]

})
export class AuthenticationModule { }